'use strict';

var _ = require('lodash');
var ConfigurationFlightAssignmentService = function ConfigurationFlightAssignmentService(restangular, $http) {
  var rulesAPI = restangular.service('configuration').one('hep').one('flightentityassignment');
  function save(data) {
    _.forEach(data, function (assignment) {
      delete assignment.uid;
      delete assignment._old;
      delete assignment._original;
      delete assignment.originalRowId;
      delete assignment._links;
    });
    return rulesAPI.customPUT(data);
  }
  function remove(data) {
    _.forEach(data, function (assignment) {
      delete assignment.uid;
      delete assignment._old;
      delete assignment._original;
      delete assignment.originalRowId;
      delete assignment._links;
    });
    return $http({
      method: 'DELETE',
      url: rulesAPI.getRestangularUrl(),
      data: data,
      headers: {
        'Content-Type': 'application/json;charset=UTF-8'
      }
    });
  }
  return {
    save: save,
    remove: remove
  };
};
ConfigurationFlightAssignmentService.$inject = ['Restangular', '$http'];
module.exports = ConfigurationFlightAssignmentService;